import { useEffect, useMemo, useState } from "react"
import { getUsers } from "../../services/dashboard";
import { Link } from "react-router-dom";

export const Users = () => {
    const [users, setUsers] = useState([]);
    const [sortBy, setSortBy] = useState(null);

    const sortedUsers = useMemo(() => {
        if (!sortBy) return users;

        return [...users].sort((a, b) => {
            if (sortBy === 'id-asc') return a.id - b.id;
            if (sortBy === 'id-desc') return b.id - a.id;
            if (sortBy === 'createdAt-asc') return new Date(a.createdAt) - new Date(b.createdAt);
            if (sortBy === 'createdAt-desc') return new Date(b.createdAt) - new Date(a.createdAt);
            if (sortBy === 'updatedAt-asc') return new Date(a.updatedAt) - new Date(b.updatedAt);
            if (sortBy === 'updatedAt-desc') return new Date(b.updatedAt) - new Date(a.updatedAt);
        });
    }, [users, sortBy])

    useEffect(() => {
        getUsers().then(response => {
            const data = response.data;
            setUsers(data.data)
        }).catch(err => {
            const status = err.response.status;
            if (status === 403) {
                window.location.href = "/login"
            }
        })
    }, []);

    return (
        <section className="p-8 text-[black] users">
            <h1 className="text-3xl pb-3">Users</h1>
            <table>
                <thead>
                    <tr>
                        <th scope="col">
                            ID
                            <button onClick={() => setSortBy("id-asc")} className="pl-2">
                                ↑
                            </button>
                            <button onClick={() => setSortBy("id-desc")} className="pl-1">
                                ↓
                            </button>
                        </th>
                        <th scope="col">
                            Created At
                            <button onClick={() => setSortBy("createdAt-asc")} className="pl-2">
                                ↑
                            </button>
                            <button onClick={() => setSortBy("createdAt-desc")} className="pl-1">
                                ↓
                            </button>
                        </th>
                        <th scope="col">
                            Updated At
                            <button onClick={() => setSortBy("updatedAt-asc")} className="pl-2">
                                ↑
                            </button>
                            <button onClick={() => setSortBy("updatedAt-desc")} className="pl-1">
                                ↓
                            </button>
                        </th>
                        <th scope="col">Completed</th>
                        <th scope="col">Paid</th>
                        <th scope="col">Name</th>
                        <th scope="col">Surname</th>
                        <th scope="col">Email</th>
                        <th scope="col">Website</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedUsers.map((user, index) => (
                        <tr key={user.id}>
                            <td><Link to={`/dashboard/users/${user.id}`}>{user.id}</Link></td>
                            <td>{user.createdAt}</td>
                            <td>{user.updatedAt}</td>
                            <td>{user.completed === 1 ? "true" : "false"}</td>
                            <td>{user.paid === 1 ? "true" : "false"}</td>
                            <td>{user.name}</td>
                            <td>{user.surname}</td>
                            <td>{user.email}</td>
                            <td>{user.website}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </section>
    )
}